module.exports = __webpack_public_path__ + "media/עגבנייה.0b66c4cd.mp3";